import lozad from "lozad";
import moment from "moment";

// http://detectmobilebrowsers.com/
(function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);
// some laptops reports "tablet" as a part of the useragent
(function (a) { (jQuery.browser = jQuery.browser || {}).tablet = /ipad|android|android 3.0|xoom|sch-i800|playbook|kindle|nexus/i.test(a) })(navigator.userAgent || navigator.vendor || window.opera);

$(function() {
    var observer = lozad();
    observer.observe();

    moment.locale(document.querySelector("html").getAttribute("lang"));

    if (/(MSIE |Trident.*rv[ :])([0-9]+)/ig.test(navigator.userAgent)) {
        $("html").addClass("ie");
    }

    $.browser = $.extend($.browser, {
        orientation: (Math.abs(window.orientation || 90) - 90 === 0 ? "landscape" : "portrait"),
        pixelratio: (window.devicePixelRatio || 1),
        ismobile: ("ontouchstart" in document.documentElement)
    });

    $.browser = $.extend($.browser, {
        width: $.browser.orientation === "landscape" ? screen.availHeight : screen.availWidth,
        height: $.browser.orientation === "landscape" ? screen.availWidth : screen.availHeight,
        flash: function () {
            var hasFlash = false;
            try {
                // ReSharper disable once ConditionIsAlwaysConst
                if (new ActiveXObject("ShockwaveFlash.ShockwaveFlash"))
                    hasFlash = true;
            } catch (e) {
                if (navigator.mimeTypes
                    && navigator.mimeTypes["application/x-shockwave-flash"] != undefined
                    && navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin) {
                    hasFlash = true;
                }
            }
            return hasFlash;
        }
    });

    var $body = $("body");
    FormHandler.InitForms($body);
    WidgetHandler.InitWidgets($body);
    TabHandler.InitTabs($body);

    var modalType = Utils.GetUrlParamByName("modal");
    if (modalType !== "") {
        var guid;
        switch (modalType) {
            case "confirmpayment":
                if (Utils.GetUrlParamByName("paymentstatus") !== "") {
                    ModalHandler.DepositConfirmation({ action: Utils.GetUrlParamByName("paymentstatus") });
                }
                break;
            case "login":
                ModalHandler.AuthenticateModal(location.href.replace(location.search, ''));
                break;
            case "loginfailed":
                ModalHandler.AuthenticationFailedModal(location.href.replace(location.search, ''));
                break;
            case "campaignform":
                guid = Utils.GetUrlParamByName("guid");
                if (guid === "" || !/^[0-9a-f]{8}\-([0-9a-f]{4}\-){3}[0-9a-f]{12}$/ig.test(guid))
                    break;
                ModalHandler.ConfirmCampaignForm({ externalId: guid });
                break;
        }
    }

    if (Utils.GetUrlParamByName("gid") !== "") {
        var options = {
            gameid: parseInt(Utils.GetUrlParamByName("gid"))
        };
        if (Utils.GetUrlParamByName("a")) {
            options["assets"] = Utils.GetUrlParamByName("a");
        }
        ModalHandler.ScratchTicketClientModal(options);
    }

    if ($body.data("autoupdatebalance") && Utils.UserIsNyxActive()) {
        var interval = parseInt($body.data("autoupdatebalance"));
        setInterval(function () {
            $(document).trigger("updatemybalance");
        }, interval * 1000);
    }

    Utils.RetrySession();

    $("a,button,input[type='submit']").filter("[data-fseventcategory]").on('click', function () {
        var eventCategory = $(this).data("fseventcategory");
        if (eventCategory && typeof (eventCategory) !== "undefined"){
            if (typeof (dataLayer) !== "undefined") {
                dataLayer.push({ "event": "FsEvent", "eventCategory": eventCategory });
            }
        }
    });

    $('a[href^="/globalassets/"]').on('click', function () {
        var doc = $(this).attr("href");
        if (doc && typeof (doc) !== "undefined") {
            if (typeof (dataLayer) !== "undefined") {
                dataLayer.push({ "event": "FsEvent", "eventCategory": "DownloadDocument", "eventAction": doc });
            }
        }
    });

    $("a[href^='/Account/Logout']").click(function() {
        if (window.ReactNativeWebView)
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: "login", payload: null }));
    });

    $("a,button,input[type='submit']").filter(".autoclick").each(function () {
        var $this = $(this),
            href = $this.attr("href");
        setTimeout(function () {
            if (href) {
                if (href.startsWith("javascript:")) {
                    href = href.replace("javascript:", "");
                    eval(href);
                }
                else {
                    window.location = href;
                }
            }
            else {
                $(this).click();
            }
        }, 500);
    });
});


